import React from 'react';
import FinancialRecoveryProgram from '../components/FinancialRecoveryProgram';

const FinancialRecoveryProgramPage = () => {
  return (
    <div className="FinancialRecoveryProgram-page">
      <FinancialRecoveryProgram />
    </div>
  );
};

export default FinancialRecoveryProgramPage;
